import deleteDocument from 'api/v2/repository/deleteDocument';
import useMutation from 'hooks/react-query/useMutation';
import useQueryClient from 'hooks/react-query/useClientQuery';

import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import showToast from 'utils/toast';

const useDeleteDocument = () => {
  const queryClient = useQueryClient();

  const deleteDocumentAPI = useMutation({
    mutationFn: deleteDocument,
    onSuccess: () => {
      showToast(
        { title: 'Document deleted successfully' },
        { type: 'success' },
      );

      queryClient.invalidateQueries([
        DocumentsRepositoryCacheKeys.DocumentsList,
      ]);

      queryClient.invalidateQueries([
        DocumentsRepositoryCacheKeys.HasDocuments,
      ]);
    },
  });

  return deleteDocumentAPI;
};

export default useDeleteDocument;
